const WORKPLACE_INFO_SECTION = { id: "workplaceInfo", label: "Workplace Info" } as const;
const PAY_AND_SCHEDULE_SECTION = { id: "payAndSchedule", label: "Pay and Schedule" } as const;
const WORKPLACE_LOCATION_SECTION = { id: "workplaceLocation", label: "Location" } as const;
const REQUIREMENTS_SECTION = { id: "requirements", label: "Requirements" } as const;

export const PLACEMENT_DETAILS_SECTIONS = [
  WORKPLACE_INFO_SECTION,
  PAY_AND_SCHEDULE_SECTION,
  WORKPLACE_LOCATION_SECTION,
  REQUIREMENTS_SECTION,
] as const;

export type PlacementDetailsSectionId = (typeof PLACEMENT_DETAILS_SECTIONS)[number]["id"];

export const WORKPLACE_INFO_SECTION_ID = WORKPLACE_INFO_SECTION.id;
export const PAY_AND_SCHEDULE_SECTION_ID = PAY_AND_SCHEDULE_SECTION.id;
export const WORKPLACE_LOCATION_SECTION_ID = WORKPLACE_LOCATION_SECTION.id;
export const REQUIREMENTS_SECTION_ID = REQUIREMENTS_SECTION.id;

export const PLACEMENT_DETAILS_SECTIONS_WITHOUT_REQUIREMENTS = [
  WORKPLACE_INFO_SECTION,
  PAY_AND_SCHEDULE_SECTION,
  WORKPLACE_LOCATION_SECTION,
] as const;

export const PLACEMENT_DETAILS_SECTION_IDS = [
  WORKPLACE_INFO_SECTION_ID,
  PAY_AND_SCHEDULE_SECTION_ID,
  WORKPLACE_LOCATION_SECTION_ID,
  REQUIREMENTS_SECTION_ID,
] as const;

export const PLACEMENT_DETAILS_SECTION_IDS_WITHOUT_REQUIREMENTS = [
  WORKPLACE_INFO_SECTION_ID,
  PAY_AND_SCHEDULE_SECTION_ID,
  WORKPLACE_LOCATION_SECTION_ID,
] as const;

const PLACEMENT_DETAILS_SECTION_ID_SET = new Set<string>(PLACEMENT_DETAILS_SECTION_IDS);

export function isPlacementDetailsSectionId(value: string): value is PlacementDetailsSectionId {
  return PLACEMENT_DETAILS_SECTION_ID_SET.has(value);
}
